<template>
  <idc-component-adjustment-role-summary :can-edit="canEdit" />
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    name: 'DashboardAdjustmentRole',
    components: {
      IdcComponentAdjustmentRoleSummary: () => import('@/components/idc/adjustment/role/Summary.vue'),
    },
    props: {
      canEdit: {
        type: Boolean,
        default: () => false,
      },
    },
  })
</script>
